import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Clients from "./pages/Clients";
import Foods from "./pages/Foods";
import Intake from "./pages/Intake";
import Measurements from "./pages/Measurements";
import StrengthProgress from "./pages/StrengthProgress";
import Attendance from "./pages/Attendance";
import Pantry from "./pages/Pantry";
import MealTemplates from "./pages/MealTemplates";
import TrainingTemplates from "./pages/TrainingTemplates";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import AdminManagement from "./pages/AdminManagement";

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/clients"} component={Clients} />
      <Route path={"/foods"} component={Foods} />
      <Route path={"/intake"} component={Intake} />
      <Route path={"/measurements"} component={Measurements} />
      <Route path={"/strength-progress"} component={StrengthProgress} />
      <Route path={"/attendance"} component={Attendance} />
      <Route path={"/pantry"} component={Pantry} />
      <Route path={"/meal-templates"} component={MealTemplates} />
      <Route path={"/training-templates"} component={TrainingTemplates} />
      <Route path={"/recipes/:id"} component={RecipeDetail} />
      <Route path={"/recipes"} component={Recipes} />
      <Route path={"/admin"} component={AdminManagement} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
